import { css } from 'styled-components';

const DefaultNeutralDark400ToRgba = (alpha = 1) => `rgba(37, 50, 86, ${alpha})`;

/** @deprecated prefer using the `theme` prop made available by `<ThemeProvider>` in styled-components */
export const theme = {
  colors: {
    admin: {
      adminContentHeadingText: '#848484',
      adminContentWrapperBackground: '#f3f5f8',
      table: {
        bulkActionsBorder: '#E6EAEF',
        bulkActionsPlainText: '#253256',
        bulkActionsLink: '#3168A8',
        bulkActionsText: '#7e7e7e',
        bulkActionsTextV2: '#7e7e7e',
      },
    },
    common: {
      input: {
        default: DefaultNeutralDark400ToRgba(0.8),
        hover: DefaultNeutralDark400ToRgba(),
        disabled: DefaultNeutralDark400ToRgba(0.25),
        placeholder: {
          default: DefaultNeutralDark400ToRgba(0.5),
          hover: DefaultNeutralDark400ToRgba(0.8),
          disabled: DefaultNeutralDark400ToRgba(0.25),
        },
      },
      label: {
        default: DefaultNeutralDark400ToRgba(0.25),
        hover: DefaultNeutralDark400ToRgba(0.5),
      },
      span: DefaultNeutralDark400ToRgba(0.5),
    },
    learner: {
      academies: {
        errors: {
          heading: '#848484',
          description: '#848484',
        },
      },
    },
    neutral: {
      dark: {
        900: '#06080E',
        800: '#0C111D',
        700: '#12192B',
        600: '#192139',
        500: '#1F2947',
        400: '#253256',
        300: '#2B3A64',
        200: '#314272',
        100: '#374B80',
        50: '#3D538F',
      },
      light: {
        900: '#8194B1',
        800: '#8D9FB9',
        700: '#9AAAC1',
        600: '#A6B4C9',
        500: '#B3BFD0',
        400: '#C0CAD8',
        300: '#CCD4E0',
        200: '#D9DFE8',
        100: '#E6EAEF',
        50: '#F2F4F7',
      },
      alpha: {
        900: 'rgba(6, 8, 14, .80)',
        800: 'rgba(6, 8, 14, .72)',
        700: 'rgba(6, 8, 14, .64)',
        600: 'rgba(6, 8, 14, .56)',
        500: 'rgba(6, 8, 14, .48)',
        400: 'rgba(6, 8, 14, .40)',
        300: 'rgba(6, 8, 14, .32)',
        200: 'rgba(6, 8, 14, .24)',
        100: 'rgba(6, 8, 14, .16)',
        50: 'rgba(6, 8, 14, .08)',
      },
    },
    primary: {
      blue: {
        900: '#092A86',
        800: '#0A3099',
        700: '#0B36AC',
        600: '#0C3CC0',
        500: '#0E42D3',
        400: '#0F48E6',
        300: '#1952F0',
        200: '#2C61F1',
        100: '#3F70F3',
        50: '#527EF4',
      },
      red: {
        900: '#A9190F',
        800: '#BC1B10',
        700: '#CE1F12',
        600: '#E12214',
        500: '#EB2C1E',
        400: '#ED3E31',
        300: '#EF4E43',
        200: '#F06056',
        100: '#F4847C',
        50: '#F5958E',
      },
      yellow: {
        900: '#B49104',
        800: '#C8A104',
        700: '#DCB104',
        600: '#F0C105',
        500: '#FACB0F',
        400: '#FBCF23',
        300: '#FBD437',
        200: '#FBD84B',
        100: '#FCDC5F',
        50: '#FCE173',
      },
    },
    secondary: {
      green: {
        900: '#2A792A',
        800: '#308830',
        700: '#359735',
        600: '#3AA63A',
        500: '#40B540',
        400: '#4ABF4A',
        300: '#59C559',
        200: '#68CA68',
        100: '#77CF77',
        50: '#86D586',
      },
      orange: {
        900: '#B44A04',
        800: '#C85204',
        700: '#DC5B04',
        600: '#F06305',
        500: '#FA6D0F',
        400: '#FB7923',
        300: '#FB8537',
        200: '#FB924B',
        100: '#FC9E5F',
        50: '#FCAA73',
      },
      purple: {
        900: '#46178C',
        800: '#4F1A9E',
        700: '#571DAF',
        600: '#6020C1',
        500: '#6922D2',
        400: '#722CDC',
        300: '#7F3EDF',
        200: '#8A50E2',
        100: '#9661E5',
        50: '#A273E8',
      },
      teal: {
        900: '#178C65',
        800: '#1A9E72',
        700: '#1DAF7E',
        600: '#20C18B',
        500: '#22D298',
        400: '#2DDDA2',
        300: '#3EDFAA',
        200: '#50E2B1',
        100: '#61E5B9',
        50: '#73E8C1',
      },
    },
  },
};

export const WithTransitionCss = css`
  transition: all 0.3s ease-in-out;
`;

export const WithBorderBoxCss = css`
  box-sizing: border-box;
`;
